import {
	SESSION_EXPIRED,
	ERROR,
	RESET_ERROR,
	AUTHENTICATE_SUCCESS
} from './ActionTypes';

// Utility function
function createReducer(initialState, handlers) {
	return function(state = initialState, action) {
		if (handlers.hasOwnProperty(action.type)) {
			return handlers[action.type](state, action);
		} else {
			return state;
		}
	};
}

const initialState = {
	errorText: '',
	sessionExpired: false
};

// Case reducer
function setSessionError(state, action) {
	return {
		...state,
		errorText: 'Votre session a expiré.',
		sessionExpired: true
	};
}

// Case reducer
function setError(state, action) {
	return {
		errorText: action.errorText,
		needAuth: true
	};
}

// Case reducer
function resetError(state, action) {
	return {
		...initialState
	};
}

// Slice reducer
const errorReducer = createReducer(initialState, {
	SESSION_EXPIRED: setSessionError,
	ERROR: setError,
	RESET_ERROR: resetError,

	// HOTFIX: reset error after auth. success to prevent display error modal after fail auth. then success auth.
	'user/SET': resetError
});

export default errorReducer;



// WEBPACK FOOTER //
// ./src/js/app/errorReducer.js